import { Component, ViewChild, Input, inject, OnInit } from '@angular/core';
import { GlobalInsightsComponent } from '../global-insights/global-insights.component';
import { ComparisonInsightsComponent } from '../comparison-insights/comparison-insights.component';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';
import { LocationSelectComponent } from 'src/app/shared/location-select/location-select.component';
import { LocationAccessService } from 'src/app/services/location-access.service';

@Component({
    selector: 'app-operational-dashboard',
    templateUrl: './operational-dashboard.component.html',
    styleUrls: ['./operational-dashboard.component.scss'],
    standalone: false
})
export class OperationalDashboardComponent implements OnInit {
   authService = inject(AuthService);
   private locationAccessService = inject(LocationAccessService);

   componentName="OPERATIONAL";
   activeTab = "0";
   selectedDays = 90;
   date: any = {};
   filterValues:any = {};
   @ViewChild('global') global!:GlobalInsightsComponent
   @ViewChild('comparison') comparison!:ComparisonInsightsComponent
   @ViewChild("locationSelectComp") locationSelectComp!: LocationSelectComponent;
   filter:any = {
    duration: 90, 
    ...this.locationAccessService.buildAuthorizedFilters(
      this.locationAccessService.buildInitialFilters(this.authService.user),
      this.authService.user
    ),
    serviceGroup: "All",
    resCode: "All"
  };
  @Input() deId=false;
  loc_filter_breakdown= 'Region';
  auditorSelection:any = {};
  loading!: boolean;
  footprint:string = environment.footprint;
  locationSelectFilter: any = {region:[], campus:[] , facility:[] , changeValue: true};

  constructor(){
    this.setInitialFilters();
  }

  ngOnInit(){
    this.locationSelectFilter = this.locationAccessService.buildInitialFilters(this.authService.user, {
      footprint: this.footprint,
      changeValue: true
    });
  }

  tabChanged(event: any){
    if(event.index==0){
      this.componentName= "Global"
      this.global.refreshData();
    }
    else if(event.index==1){
      this.componentName= "Camparison"
      this.comparison.refreshData();
    }
    else if(event.index==2){
      this.componentName= "Variance"
      //this.Auditor.refreshData();
    }
    else if(event.index==3){
      this.componentName= "Waste"
      //this.Auditor.refreshData();
    }
    else if(event.index==4){
      this.componentName= "Practice"
      //this.Auditor.refreshData();
    }
    else if(event.index==5){
      this.componentName= "Auditor"
      //this.Auditor.refreshData();
    }
  }
  triggerRefresh(){
    this.global.refreshData()
  }

  updatedFilterValue(filter: any){
    this.filterValues = filter;
  }

  updatedDate(filter: any){
    this.date.startDate = new Date(this.gdfs(filter.startDate)).setHours(0,0,0);
    this.date.endDate = new Date(this.gdfs(filter.endDate)).setHours(23,59,59);
  }

  gdfs(s: any){
    // get date from string 
    const d = s.substring(0,10).split('-')
    return d[1] + '-' + d[2] + '-' + d[0]
  }

  resCodeselected(event: any){
    this.global.filter.resCode = event.resCode;
    this.global.filterRecord();
  }

  onServiceGrpChanged(event: any){
    this.global.loading=true;
    this.global.overViewLoading = true
    this.global.adcLoading = true;
    this.global.verifiedLoading = true;
    this.global.medLoading = true;
    this.global.filter.serviceGroup = event.serviceGroup;
    this.global.filterRecord();
  }

  onLocationChanged(event: any){
    this.global.loading=true;
    this.global.overViewLoading = true
    this.global.adcLoading = true;
    this.global.verifiedLoading = true;
    this.global.medLoading = true;
    const sanitized = this.locationAccessService.sanitizeSelectedFilters(event, this.authService.user);
    this.locationAccessService.applyAuthorizedFilters(this.global.filter, sanitized, this.authService.user);

    if(this.locationAccessService.hasAll(sanitized.region)) {
        this.global.filter.adminId = []
        this.auditorSelection = {}
    }
    this.loc_filter_breakdown = this.locationAccessService.getFilterBreakdown(sanitized, {
      allLarge: 'Region',
      allSmall: 'Facility',
      regionSelected: 'Campus',
      campusSelected: 'Facility',
      facilitySelected: 'Facility',
      locationGroupSelected: 'Location Group'
    }, this.footprint);
    this.global.filter.$sortOrder = -1;
    this.global.filterRecord();
  }

  facilityLocationChange(event: any){
    this.locationAccessService.applyAuthorizedFilters(this.global.filter, event, this.authService.user);
    this.loc_filter_breakdown = this.locationAccessService.hasAll(event.locationGroup) ? 'Facility' : 'Location Group';
    this.global.filter.$sortOrder = -1;
    this.global.filterRecord();
  }

  setInitialFilters() {
    this.filter = {
      duration: 90,
      ...this.locationAccessService.buildAuthorizedFilters(
        this.locationAccessService.buildInitialFilters(this.authService.user),
        this.authService.user
      ),
      serviceGroup: "All",
      resCode: "All"
    };
  }

  onLocationSelectInitialized(initialFilter: any): void {
    this.locationAccessService.applyAuthorizedFilters(this.filter, initialFilter, this.authService.user);
    this.global.refreshData();
    this.comparison.refreshData();
  }

}
